module.exports = __webpack_public_path__ + "static/img/reward4-shadowed.eabfa339.png";